// Engine API: agent approval requests.
// Backed by ~/Dev/seitiate/app/api/v1/agent_approval_requests.py.

import { engineFetchJson } from '@/lib/engineHttp';
import type {
  ApprovalDecisionBody,
  ApprovalListResponse,
  ApprovalRequestRead,
  ApprovalRequestStatus,
} from './agentBoardTypes';

export interface ListApprovalRequestsParams {
  status?: ApprovalRequestStatus;
  limit?: number;
}

export async function listAgentApprovalRequests(
  params: ListApprovalRequestsParams = {},
): Promise<ApprovalListResponse> {
  const qs = new URLSearchParams();
  qs.set('status', params.status ?? 'pending');
  qs.set('limit', String(params.limit ?? 50));
  return engineFetchJson<ApprovalListResponse>(
    `/agent-approval-requests?${qs.toString()}`,
  );
}

export async function approveAgentApprovalRequest(
  id: string,
  body: ApprovalDecisionBody = {},
): Promise<ApprovalRequestRead> {
  return engineFetchJson<ApprovalRequestRead>(
    `/agent-approval-requests/${encodeURIComponent(id)}/approve`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
}

export async function denyAgentApprovalRequest(
  id: string,
  body: ApprovalDecisionBody = {},
): Promise<ApprovalRequestRead> {
  return engineFetchJson<ApprovalRequestRead>(
    `/agent-approval-requests/${encodeURIComponent(id)}/deny`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    },
  );
}
